import { ImageFromServer } from '@/components/images//ImageFromServer';
import { Card, Grid, IconButton, Stack, Typography } from '@mui/material';
import { ExerciseDTO } from '../../generated';
import { Add, Style } from '@mui/icons-material';

interface ExerciseProps {
  exercise: ExerciseDTO;
  onClick?: () => void;
}

export const DrawerExercise = (props: ExerciseProps) => {
  return (
    <>
      <Card sx={{ mx: 1, mt: 0.75, p: 1 }}>
        <Grid onClick={props.onClick} sx={{ mt: 0.5, gap: 1 }} container size={12}>
          <Grid size={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', justifyItems: 'center' }}>
            <ImageFromServer sx={{ height: '5rem', width: '5rem' }} thumbnail={false} fluid={true} alt="" id={props.exercise.imageId} />
          </Grid>
          <Grid size={9} sx={{ overflowWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', alignContent: 'center', justifyItems: 'flex-start' }}>
            <Stack sx={{ gap: 1, alignItems: 'center' }}>
              <Stack direction={'row'} sx={{ alignItems: 'center', ml: 1, mr: 'auto' }}>
                <IconButton>
                  <Add />
                </IconButton>
                <Typography sx={{ overflowWrap: 'break-word', textOverflow: 'ellipsis' }}>{props.exercise.name}</Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};
